import React from 'react';
import { faCalendarDays } from '@fortawesome/free-solid-svg-icons';
import { ClosingDateNotice } from './ClosingDateNotice';
import { formatShortBusinessDate } from '../../../slices/marketplace/closing-date/utils/closing-date-limits';

export interface ClosingDateHeldByStepNoticeProps {
    officialClosingDate?: string | null;
    stepName: string;
}

export const ClosingDateHeldByStepNotice = ({
    officialClosingDate,
    stepName,
}: ClosingDateHeldByStepNoticeProps) => (
    <ClosingDateNotice
        tone="info"
        icon={faCalendarDays}
        className="closing-date-held-by-step-notice">
        The closing date moved to{' '}
        {officialClosingDate
            ? formatShortBusinessDate(officialClosingDate)
            : ''}{' '}
        because {stepName} is still open. It moves one day later each night
        until the step is done.
    </ClosingDateNotice>
);
